import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";

function useNotFoundPage() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { lng } = useParams<{ lng: string }>();
    const homePath = `/${lng ?? "en"}`;

    const handlers = {
        handleGoBack: () => window.history.back(),
    };

    return {
        state: {},
        handlers,
        utilities: { t, homePath },
    };
}

export default useNotFoundPage;
